import ListeningLogo from '@listening/assets/imgs/logo/listeningLogoLong.svg?react';

export function SqueezeLogo() {
  return (
    <ListeningLogo
      aria-label='Listening'
      className='h-6 w-auto sm:h-8 lg:h-9'
      role='img'
    />
  );
}

export function SqueezeFooterLogo() {
  return (
    <ListeningLogo aria-label='Listening' className='h-5 w-auto' role='img' />
  );
}
